import React from "react";
import { Info } from "lucide-react";

function isValidCoord(lat, lng) {
  const la = Number(lat);
  const lo = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(lo)) return false;
  if (la === 0 && lo === 0) return false;
  if (la < -90 || la > 90) return false;
  if (lo < -180 || lo > 180) return false;
  return true;
}

/**
 * Google Maps embed.
 * Priority:
 *   1. Valid lat/lng → precise pin at those coordinates.
 *   2. Non-empty address → search the address (approximate) + small transparency badge.
 *   3. Otherwise renders nothing.
 */
export default function MapEmbed({ lat, lng, address, className = "" }) {
  const coordOk = isValidCoord(lat, lng);
  const addr = (address || "").trim();

  let src = null;
  let approximate = false;
  if (coordOk) {
    const label = encodeURIComponent(addr || `${lat},${lng}`);
    src = `https://maps.google.com/maps?q=${lat},${lng}(${label})&z=15&output=embed`;
  } else if (addr) {
    src = `https://maps.google.com/maps?q=${encodeURIComponent(addr)}&z=13&output=embed`;
    approximate = true;
  }

  if (!src) return null;

  return (
    <div
      className={`relative w-full overflow-hidden rounded-2xl border border-stone-200 ${className}`}
      style={{ aspectRatio: "16 / 9" }}
      data-testid="map-embed"
      data-map-mode={approximate ? "approximate" : "exact"}
    >
      <iframe
        title={`Localização — ${addr || "imóvel"}`}
        src={src}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        className="absolute inset-0 h-full w-full border-0"
      />
      {approximate && (
        <div
          className="absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 rounded-full bg-white/95 backdrop-blur px-3 py-1.5 text-[11px] font-medium uppercase tracking-[0.16em] text-[#103C4A] shadow-md border border-stone-200"
          data-testid="map-approximate-badge"
        >
          <Info className="h-3 w-3" />
          Localização aproximada
        </div>
      )}
    </div>
  );
}
